var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203.92 54.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#New_Gradient_Swatch_6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 89.11,
    y1: 81.96,
    x2: 167.34,
    y2: -6.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6",
    x1: 2.02,
    y1: 28.87,
    x2: 56.96,
    y2: 28.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#dddede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#bdbfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b1b3b6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.42,50.92V19.56a7.06,7.06,0,0,0-1.85-5.31,7.47,7.47,0,0,0-5.47-2,5.15,5.15,0,0,0-.56,0V43.63a7.06,7.06,0,0,0,1.85,5.3,7.49,7.49,0,0,0,5.45,2,5.72,5.72,0,0,0,.58,0Zm.71-46.28a4.66,4.66,0,1,0-4.66,4.68,4.65,4.65,0,0,0,4.66-4.68ZM136.52,35.72v7.91a7.06,7.06,0,0,0,1.85,5.3,7.55,7.55,0,0,0,5.46,2,5.62,5.62,0,0,0,.58,0V34.07c0-7.25-2-12.13-5.5-15.93s-9-6.15-15.32-6.15c-12,0-20.38,8.82-20.38,20.3,0,11.28,7.72,18.81,17.74,18.81,7.73,0,12.36-4.59,12.36-10a11.09,11.09,0,0,0-2-6.21c-1.11,5.79-4.32,9-9.47,9-5.51,0-10.36-4.17-10.36-11.79s4.86-12.6,12.13-12.6a12.11,12.11,0,0,1,8.79,3.45c2.6,2.58,4.12,6.53,4.12,12.78Zm61.56,4.84a.31.31,0,0,1-.24-.15c-5.66-7.36-16-20.94-18.3-23.9-2.38-3.11-4.25-4.13-6.71-4.13a5.73,5.73,0,0,0-4.3,1.75,7.58,7.58,0,0,0-1.7,5.21V43.63a7,7,0,0,0,1.85,5.3,7.3,7.3,0,0,0,5.33,2,3.1,3.1,0,0,0,.44,0V23.07c0-.2.09-.31.23-.31s.16,0,.23.16c3.32,4.32,15.91,20.78,18.33,23.88s4.23,4.14,6.68,4.14a5.77,5.77,0,0,0,4.32-1.73,7.63,7.63,0,0,0,1.7-5.21V19.7a7.11,7.11,0,0,0-1.86-5.32,7.32,7.32,0,0,0-5.34-2,3.39,3.39,0,0,0-.44,0V40.26c0,.2-.09.3-.22.3ZM74,43.47c-.31,0-.49-.1-.49-.31a.58.58,0,0,1,.27-.39c2.42-2,18.45-14.89,20.89-16.9,4.25-3.42,5.14-5.09,5.14-7.52a5.12,5.12,0,0,0-1.78-3.86c-1.28-1.09-3.2-1.68-6.31-1.68H64.46v.43a7.33,7.33,0,0,0,1,4c1.11,1.58,3.19,2.49,6,2.49H89.38c.31,0,.49.1.49.26s-.08.23-.28.38c-2.54,2.06-17.33,14-21,16.94-4.26,3.42-5.11,5.12-5.11,7.54a5.08,5.08,0,0,0,1.78,3.85c1.29,1.1,3.21,1.7,6.33,1.7h28.55V50.1a6.41,6.41,0,0,0-1.79-4.88c-1.39-1.28-3.19-1.75-6.58-1.75Z",
    transform: "translate(-2.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.57,20.32c0-4.54-3.49-8-8.48-7.6-10.59.81-12,12.86-5.07,13.63,7.21.8,9.79-6.82,9.93-7.25h0c0,.52.39,11-10.3,11a8.32,8.32,0,0,1-8.41-8.48c0-5.83,5.67-11.64,13.68-11.95,4.48-.17,7.44.89,9.75,3.21C51.4,17.6,50,26.45,46.22,30.81c-6.06,6.94-14.58,8.7-22.51,5.14s-10.78-13.86-6-22.48C19.51,10.29,25.93,3.23,37,3.23c14,0,21.13,9.94,19.84,21.61-1,8.94-6.41,15.42-8.93,18.16C36.81,55,20.55,57.42,10.31,51.16A17.06,17.06,0,0,1,2.12,34.55,17.06,17.06,0,0,0,9.45,46.83c8.37,5.71,22.38,6.49,32.5-4.64-10.17,7.6-22.06,7.49-30.17,2.2-7.45-4.85-9.5-14.54-5.85-24.12C4.1,28.81,7,36.73,13.5,40.86c10.06,6.43,24.73,2.73,34-7.63A19.21,19.21,0,0,0,52.37,20.6C52.28,13.35,47.23,6.85,37,6.85c-10.47,0-17.65,8.09-17.65,14.82,0,7.47,5.13,11.73,11.82,11.73S45.57,29.23,45.57,20.32Z",
    transform: "translate(-2.02)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZainLogo);
export default __webpack_public_path__ + "static/media/zain-logo.b074b60521c1d9b4fc37d53e999470d4.svg";
export { ForwardRef as ReactComponent };